import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Header from './layout/Header';
import Menu from './layout/Menu';
import Footer from './layout/Footer';

import Usuarios from '../src/components/usuarios/Index';
import CrearUsuario from '../src/components/usuarios/Crear';
import EditarUsuario from '../src/components/usuarios/Editar';

import Roles from '../src/components/roles/Index';
import CrearRol from '../src/components/roles/Crear';
import EditarRol from '../src/components/roles/Editar';

import Customers from './components/customers/Index';
import AddCustomer from './components/customers/Crear';
import EditCustomer from './components/customers/Editar';

import Suppliers from './components/suppliers/Index';
import AddSupplier from './components/suppliers/Crear';
import EditSupplier from './components/suppliers/Editar';

import Quotations from '../src/components/quotations/Index';
import AddQuotation from '../src/components/quotations/Crear';
import EditQuotation from '../src/components/quotations/Editar';

import Invoices from '../src/components/invoices/Index';
import AddInovice from '../src/components/invoices/Crear';
import EditInovice from '../src/components/invoices/Editar';

import SuppliersInvoices from '../src/components/suppliers_invoices/Index';
import AddSupplierInovice from '../src/components/suppliers_invoices/Crear';
import EditSupplierInovice from '../src/components/suppliers_invoices/Editar';

import Sales from '../src/components/sales/Index';
import AddSale from '../src/components/sales/Crear';
import EditSale from '../src/components/sales/Editar';

import Accounting from '../src/components/accounting/Index';
import AddAccounting from '../src/components/accounting/Crear';
import EditAccounting from '../src/components/accounting/Editar';

import Movements from '../src/components/movements/Index';
import AddMovement from '../src/components/movements/Crear';
import EditMovement from '../src/components/movements/Editar';

import MenuConfiguracion from '../src/components/menuconfiguracion/Index';
import EditarConfiguracion from '../src/components/menuconfiguracion/Editar';
import AddConfiguracion from '../src/components/menuconfiguracion/Crear';

import ListaTablas from '../src/components/MenuPrincipal/Index';
import Master from '../src/components/Master/Listar';

import ConsultasBasicas from './components/consultas_basicas/Index';
import ReporteBalanceFlujo from  './components/balance_flujo/Index';
import ReporteBitacoraVisitas from './components/bitacora_visitas/Consultar';
import ReporteFactAportesMunicipales from './components/fact_aportes/Consultar';
import ReporteFactComercializadores from './components/fact_comercializadores/Consultar';
import ReporteFactMunicipio from './components/fact_municipio/Consultar';
import ReporteFactOperadoresRed from './components/fact_operadores/Consultar';
import ReportePQR from './components/pqr/Consultar';
import Categorias from './components/categorias/Index';
import CrearCategorias from './components/categorias/Crear';
import EditarCategorias from './components/categorias/Editar';

import Home from './components/home/Index';
function App() {
  const ux = localStorage.getItem("username");
  return (
    
    <Router>
      {ux != null ? <Header /> : ''}
      {ux != null ? <Menu /> : ''}
      {ux != null ? <Route exact path="/" component={Home}></Route> :
        <Route exact path="/" component={Login}></Route>}

        <Route exact path="/pages/:id" component={ux != null ? Master : Login}></Route> 
        <Route exact path="/home" component={ux != null ? Home : Login}></Route> 
       <Route exact path="/MenuConfiguracion" component={ux != null ? MenuConfiguracion : Login}></Route> 
       <Route exact path="/EditarConfiguracion/:id" component={ux != null ? EditarConfiguracion : Login}></Route>
       <Route exact path="/AddConfiguracion" component={ux != null ? AddConfiguracion : Login}></Route>

       <Route exact path="/Tablas/:id" component={ux != null ? ListaTablas : Login}></Route> 

      <Route exact path="/MasterUsuarios" component={ux != null ? Usuarios : Login}></Route>
      <Route exact path="/AddUsuarios" component={ux != null ? CrearUsuario : Login}></Route>
      <Route exact path="/UpUsuarios/:id" component={ux != null ? EditarUsuario : Login}></Route>

      <Route exact path="/MasterRoles" component={ux != null ? Roles : Login}></Route>
      <Route exact path="/AddRoles" component={ux != null ? CrearRol : Login}></Route>
      <Route exact path="/UpRoles/:id" component={ux != null ? EditarRol : Login}></Route>

      <Route exact path="/MasterCustomers" component={ux != null ? Customers : Login}></Route>
      <Route exact path="/AddCustomers" component={ux != null ? AddCustomer : Login}></Route>
      <Route exact path="/UpCustomers/:id" component={ux != null ? EditCustomer : Login}></Route>

      <Route exact path="/MasterSuppliers" component={ux != null ? Suppliers : Login}></Route>
      <Route exact path="/AddSuppliers" component={ux != null ? AddSupplier : Login}></Route>
      <Route exact path="/UpSuppliers/:id" component={ux != null ? EditSupplier : Login}></Route>

      <Route exact path="/MasterQuotations" component={ux != null ? Quotations : Login}></Route>
      <Route exact path="/AddQuotations" component={ux != null ? AddQuotation : Login}></Route>
      <Route exact path="/UpQuotations/:id" component={ux != null ? EditQuotation : Login}></Route>

      <Route exact path="/MasterInvoices" component={ux != null ? Invoices : Login}></Route>
      <Route exact path="/AddInvoices" component={ux != null ? AddInovice : Login}></Route>
      <Route exact path="/UpInvoices/:id" component={ux != null ? EditInovice : Login}></Route>

      <Route exact path="/MasterSuppliersInvoices" component={ux != null ? SuppliersInvoices : Login}></Route>
      <Route exact path="/AddSuppliersInvoices" component={ux != null ? AddSupplierInovice : Login}></Route>
      <Route exact path="/UpSuppliersInvoices/:id" component={ux != null ? EditSupplierInovice : Login}></Route>

      <Route exact path="/MasterSales" component={ux != null ? Sales : Login}></Route>
      <Route exact path="/AddSales" component={ux != null ? AddSale : Login}></Route>
      <Route exact path="/UpSales/:id" component={ux != null ? EditSale : Login}></Route>

      <Route exact path="/MasterAccounting" component={ux != null ? Accounting : Login}></Route>
      <Route exact path="/AddAccounting" component={ux != null ? AddAccounting : Login}></Route>
      <Route exact path="/UpAccounting/:id" component={ux != null ? EditAccounting : Login}></Route>

      <Route exact path="/MasterMovements" component={ux != null ? Movements : Login}></Route>
      <Route exact path="/AddMovements" component={ux != null ? AddMovement : Login}></Route>
      <Route exact path="/UpMovements/:id" component={ux != null ? EditMovement : Login}></Route>

      <Route exact path="/MasterConsultasIngreso" component={ux != null ? ConsultasBasicas : Login}></Route>
      <Route exact path="/MasterBalanceFlujo" component={ux != null ? ReporteBalanceFlujo : Login}></Route>
      <Route exact path="/MasterConsultasBitacoraVisitas" component={ux != null ? ReporteBitacoraVisitas : Login}></Route>
      <Route exact path="/MasterConsultasFactAportes" component={ux != null ? ReporteFactAportesMunicipales : Login}></Route>
      <Route exact path="/MasterConsultasFactComer" component={ux != null ? ReporteFactComercializadores : Login}></Route>
      <Route exact path="/MasterConsultasFactMun" component={ux != null ? ReporteFactMunicipio : Login}></Route>
      <Route exact path="/MasterConsultasFactOper" component={ux != null ? ReporteFactOperadoresRed : Login}></Route>
      <Route exact path="/MasterConsultasPQR" component={ux != null ? ReportePQR : Login}></Route>

      {ux != null ? <Footer /> : ''}
    </Router>
  );
}

export default App;
